import { css } from 'styled-components';
import { colors } from '../../providers/BKJThemeProvider/BKJColors.js';
export const createBKJTextInputThemeVariantStyles = (opts = {}) => {
    if (!opts.border)
        opts.border = `1px solid #6D7682`;
    if (!opts.fontSize)
        opts.fontSize = '14px';
    if (!opts.borderRadius)
        opts.borderRadius = '8px';
    if (!opts.padding)
        opts.padding = '0 12px';
    if (!opts.boxShadow)
        opts.boxShadow = '0 0 0 0 transparent';
    if (!opts.invalidBorderColor)
        opts.invalidBorderColor = `#AC1936`;
    if (!opts.disabledBorder)
        opts.disabledBorder = `1px solid ${colors.Grey3}`;
    if (!opts.disabledBackgroundColor)
        opts.disabledBackgroundColor = 'Grey3';
    if (!opts.minHeight)
        opts.minHeight = '38px';
    if (!opts.height)
        opts.height = '38px';
    if (!opts.width)
        opts.width = '100%';
    if (!opts.fontFamily)
        opts.fontFamily = 'PoppinsTextMedium';
    if (!opts.placeholderColor)
        opts.placeholderColor = 'TextDisabled';
    return css `
    ${({ theme }) => theme.fonts[opts.fontFamily]};
    font-size: ${opts.fontSize};
    background-color: ${colors[opts.backgroundColor]};
    background: ${colors[opts.background]};
    background-image: none !important;
    color: ${colors[opts.fontColor]};
    outline: none;

    &::placeholder {
      color: ${colors[opts.placeholderColor]};
    }

    &:focus {
      border-color: ${colors[opts.focusBorderColor]};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:first-line,
    &focus:-webkit-autofill {
      ${({ theme }) => theme.fonts.PoppinsTextMedium};
      border-color: #e5dfa1 !important;
      box-shadow: 0 0 0 100px #fffff1 inset !important;
    }
    &:disabled {
      background-color: ${colors[opts.disabledBackgroundColor]};
      border: ${opts.disabledBorder};
      cursor: unset;
      color: ${({ theme }) => theme.colors.TextDisabled};
    }
    &:enabled {
      &:active {
        background-color: ${colors[opts.activeBackgroundColor]};
      }
    }

    ${({ error }) => error &&
        css `
        &:invalid {
          border-color: ${opts.invalidBorderColor};
        }
      `};

    ${({ elementType, isOpen, openBorderLocation = 'bottom', variant, theme }) => {
        const cssArray = [];
        switch (elementType) {
            case 'Label': {
                break;
            }
            case 'InputWrapper': {
                if (variant === 'ComboBoxSeamlessRounded' && isOpen) {
                    cssArray.push(`
              &::before {
                position: absolute;
                height: 100%;
                width: 100%;
                z-index: -1;
                content: '';
                border-${openBorderLocation}: 0;
                border-${openBorderLocation}-color: ${theme.colors.White};
                border-${openBorderLocation}-right-radius: 0px;
                border-${openBorderLocation}-left-radius: 0px;
              }
            `);
                }
                break;
            }
            case 'Input': {
                opts.margin && cssArray.push(`margin: ${opts.margin};`);
                opts.height && cssArray.push(`height: ${opts.height};`);
                opts.minHeight && cssArray.push(`min-height: ${opts.minHeight};`);
                opts.maxHeight && cssArray.push(`max-height: ${opts.maxHeight};`);
                opts.width && cssArray.push(`width: ${opts.width};`);
                opts.minWidth && cssArray.push(`min-width: ${opts.minWidth};`);
                opts.maxWidth && cssArray.push(`max-width: ${opts.maxWidth};`);
                opts.border && cssArray.push(`border: ${opts.border};`);
                opts.padding && cssArray.push(`padding: ${opts.padding};`);
                opts.borderRadius && cssArray.push(`border-radius: ${opts.borderRadius};`);
                if (variant === 'ComboBoxSeamlessRounded') {
                    if (isOpen) {
                        cssArray.push(`
                  border-${openBorderLocation}: 0;
                  border-${openBorderLocation}-color: ${theme.colors.White};
                  border-${openBorderLocation}-right-radius: 0px;
                  border-${openBorderLocation}-left-radius: 0px;
                `);
                    }
                }
                break;
            }
        }
        return cssArray.join(';');
    }};
  `;
};
//# sourceMappingURL=BKJTextInput.utils.js.map